import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { baseUrl } from 'supporticon/utils/justgiving'
import { selectCustomSupporterPageUnclaimed } from '../../store/customSupporterPages'
import { selectFundraisingPage } from '../../store/fundraisingPage'
import { jgLight } from '../../assets'

import FlatModal from '../../components/ui/FlatModal'
import ContentSection from '../../components/ui/ContentSection'

const CustomSupporterPageClaim = ({
  config,
  fundraisingPage,
  params,
  router
}) => {
  const holdingUserGuid = config.userGuid || 'a78a50f5-0a4f-4bc6-99f6-24f65e2999db'
  const claimablePage = config.allow && fundraisingPage.ownerGuid === holdingUserGuid
  const claimPageUrl = [
    baseUrl('api'),
    config.apiKey || '0f1b3633',
    'v1/fundraising/unclaimedpages',
    params.slug,
    'claim'
  ].join('/')

  useEffect(() => {
    if (!claimablePage) router.push(`/fundraising/${params.slug}`)
  }, [])

  return (
    <FlatModal
      shouldCloseOnOverlayClick={false}
      onRequestClose={() => router.push(`/fundraising/${params.slug}`)}
      contentLabel='Redirecting'
      isOpen>
      <ContentSection
        copy={config.copy}
        title={config.title}
        spacing='expanded'
        alignment='center'
        copyAlignment='center'
        buttons={[
          {
            background: 'justgiving',
            label: (
              <span>
                Connect to{' '}
                <img src={jgLight} alt='JustGiving' style={{ height: '1em' }} />
              </span>
            ),
            url: claimPageUrl
          }
        ]}
      />
    </FlatModal>
  )
}

const mapState = (state, props) => ({
  config: selectCustomSupporterPageUnclaimed(state, props),
  fundraisingPage: selectFundraisingPage(state, props)
})

export default connect(mapState)(CustomSupporterPageClaim)
